import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import AdminPanel from "../panel/AdminPanel";
import "../styles/AdminBookList.css";
import { FaBook, FaPlus, FaTrash, FaEdit } from "react-icons/fa";



const AdminBookList = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [bookLists, setBookLists] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentBookList, setCurrentBookList] = useState({
    classId: null,
    className: "",
    books: [],
  });
  const [newBookName, setNewBookName] = useState("");
  const [newWriter, setNewWriter] = useState("");

  useEffect(() => {
    fetchBookLists();
  }, []);

  const fetchBookLists = async () => {
    try {
      const res = await api.get("/api/book-lists");
      console.log("API data:", res.data);
      if (Array.isArray(res.data)) {
        setBookLists(res.data);
      } else {
        setBookLists([]);
      }
    } catch (err) {
      console.error("Error fetching book lists:", err);
      setBookLists([]);
    }
  };

  const openAddModal = (classId, className) => {
    setCurrentBookList({ classId, className, books: [] });
    setModalOpen(true);
  };

  const openEditModal = (bookList) => {
    setCurrentBookList(bookList);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setNewBookName("");
    setNewWriter("");
  };

  const saveBookList = async () => {
    try {
      await api.post("/api/book-lists", currentBookList);
      fetchBookLists();
      closeModal();
    } catch (err) {
      console.error("Error saving book list:", err);
    }
  };

  const addBookToList = () => {
    if (!newBookName.trim() || !newWriter.trim()) return;
    setCurrentBookList((prev) => ({
      ...prev,
      books: [...prev.books, { name: newBookName, writer: newWriter }],
    }));
    setNewBookName("");
    setNewWriter("");
  };

  const removeBook = (idx) => {
    setCurrentBookList((prev) => ({
      ...prev,
      books: prev.books.filter((_, i) => i !== idx),
    }));
  };

  return (
    <>
      <AdminPanel onToggle={setIsSidebarCollapsed} />

      <div
        className={`admin-booklist-main ${
          isSidebarCollapsed ? "collapsed" : ""
        }`}
      >
        <h3 className="booklist-page-title">
          <FaBook style={{ marginRight: "8px" }} />
          Book List Management
        </h3>

        <div className="bl-quick-links">
          {Array.isArray(bookLists) &&
            bookLists.map((cls) => (
              <div key={cls.classId} className={`bl-card bl-${cls.classId}`}>
                <div className="bl-left">
                  <div className="bl-count">{cls.books.length} Books</div>
                  <div className="bl-label">{cls.className}</div>
                </div>
                <div className="bl-card-actions">
                  <FaPlus
                    className="bl-action-icon add"
                    onClick={() => openAddModal(cls.classId, cls.className)}
                  />
                  {cls.books.length > 0 && (
                    <FaEdit
                      className="bl-action-icon edit"
                      onClick={() => openEditModal(cls)}
                    />
                  )}
                </div>
              </div>
            ))}
        </div>

        {modalOpen && (
          <div className="bl-modal" onClick={closeModal}>
            <div
              className="bl-modal-card-modern"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>
                {currentBookList.books.length ? "Edit" : "Add"} Book List -{" "}
                {currentBookList.className}
              </h3>

              <div className="bl-form-grid">
                <label>
                  Book Name:
                  <input
                    type="text"
                    value={newBookName}
                    onChange={(e) => setNewBookName(e.target.value)}
                  />
                </label>
                <label>
                  Publisher's Name:
                  <input
                    type="text"
                    value={newWriter}
                    onChange={(e) => setNewWriter(e.target.value)}
                  />
                </label>
                <div className="bl-add-book-button-container">
                  <button onClick={addBookToList}>Add Book</button>
                </div>
              </div>

              <div className="bl-current-books">
                {currentBookList.books.map((b, idx) => (
                  <div key={idx} className="bl-book-chip">
                    {b.name} - {b.writer}{" "}
                    <span onClick={() => removeBook(idx)}>x</span>
                  </div>
                ))}
              </div>

              <div className="bl-modal-actions">
                <button onClick={saveBookList}>Save</button>
                <button onClick={closeModal}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminBookList;
